<lgb-header-gradient [height]="((type())? 180 : 100)" [background]="type()==null"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	@if(type()){
		<div class="type-container">
			<img hSkeleton="150px" [src]="type() | imgCardType"/>
		</div>
		<lgb-back name="stat-home"></lgb-back>
		<h1 class="my-4">Mes stats</h1>
		<div class="tabs tabs-box my-4">
			<a [routerLink]="router.parse('stat-overview', [type().ref])" routerLinkActive="tab-active" class="tab">Ma collection</a>
			<a [routerLink]="router.parse('stat-series', [type().ref])" routerLinkActive="tab-active" class="tab">Series</a>
		</div>
		<router-outlet />
	}
</div>